import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useLocation, useParams} from "react-router-dom"

import {StripeAuBankAccountForm, StripeAuBankAccountDisclaimer} from "@indebted/stripe"
import {DiscountMessage} from "@indebted/components/DiscountMessage"
import {Page} from "@indebted/components/Page"
import {useAnalytics} from "@indebted/analytics"

function AuDirectDebitForm({i18n, termsOfDiscountOffer, discountMessage, locale, onSubmit, publishableKey}) {
	const location = useLocation()
	const {secureCode} = useParams()
	const {track} = useAnalytics()

	if (discountMessage) {
		if (discountMessage.Eligible) {
			track("PaymentPlanSettlementOfferEligibleMessageViewed", {
				SecureCode: secureCode,
			})
		} else {
			track("PaymentPlanSettlementOfferNotEligibleMessageViewed", {
				SecureCode: secureCode,
			})
		}
	}

	return (
		<Page padded>
			<Grid container direction="column" alignItems="stretch" spacing={5} padding={0}>
				<Grid>
					<DiscountMessage discountMessage={discountMessage} />
				</Grid>
				<Grid>
					<Typography variant="h6">{i18n.Header}</Typography>
				</Grid>
				<Grid>
					<Typography>{i18n.Title}</Typography>
				</Grid>

				<Grid>
					<StripeAuBankAccountForm
						i18n={i18n}
						termsOfDiscountOffer={termsOfDiscountOffer}
						locale={locale}
						onSubmit={onSubmit}
						publishableKey={publishableKey}
						paymentMethodSelectionLink={`PaymentMethodSelection${location.search}`}
					/>
				</Grid>

				<Grid>
					<StripeAuBankAccountDisclaimer />
				</Grid>
			</Grid>
		</Page>
	)
}

export {AuDirectDebitForm}
